import type { LearningCard, QualityRating } from '@/types/learning';

const MIN_EASE_FACTOR = 1.3;
const INITIAL_EASE_FACTOR = 2.5;

export function calculateSM2(
  card: LearningCard,
  quality: QualityRating
): LearningCard {
  const now = Date.now();

  // Calculate new ease factor
  // EF' = EF + (0.1 - (5 - q) * (0.08 + (5 - q) * 0.02))
  let newEaseFactor =
    card.easeFactor + (0.1 - (5 - quality) * (0.08 + (5 - quality) * 0.02));

  if (newEaseFactor < MIN_EASE_FACTOR) {
    newEaseFactor = MIN_EASE_FACTOR;
  }

  let newInterval: number;
  let newRepetitions: number;

  if (quality < 3) {
    // Incorrect answer - reset repetitions
    newRepetitions = 0;
    newInterval = 1; // Review again in 1 day
  } else {
    // Correct answer
    newRepetitions = card.repetitions + 1;

    if (newRepetitions === 1) {
      newInterval = 1;
    } else if (newRepetitions === 2) {
      newInterval = 6;
    } else {
      newInterval = Math.round(card.interval * newEaseFactor);
    }
  }

  return {
    ...card,
    easeFactor: newEaseFactor,
    interval: newInterval,
    repetitions: newRepetitions,
    nextReviewDate: now + newInterval * 24 * 60 * 60 * 1000,
    lastReviewDate: now,
    totalReviews: card.totalReviews + 1,
    correctReviews: quality >= 3 ? card.correctReviews + 1 : card.correctReviews,
  };
}

export function createInitialCard(countryCode: string): LearningCard {
  return {
    countryCode,
    easeFactor: INITIAL_EASE_FACTOR,
    interval: 0,
    repetitions: 0,
    nextReviewDate: Date.now(),
    lastReviewDate: 0,
    totalReviews: 0,
    correctReviews: 0,
  };
}

// Convert quiz answer to quality rating
export function answerToQuality(
  correct: boolean,
  responseTimeMs: number,
  averageTimeMs: number = 5000
): QualityRating {
  if (!correct) {
    return 1;
  }

  // Fast correct = higher quality
  if (responseTimeMs < averageTimeMs * 0.5) {
    return 5; // Perfect, instant recall
  } else if (responseTimeMs < averageTimeMs) {
    return 4; // Good recall
  } else {
    return 3; // Correct but with hesitation
  }
}
